import { render, staticRenderFns } from "./stuRolls.vue?vue&type=template&id=4ef7ff40&scoped=true&"
import script from "./stuRolls.vue?vue&type=script&lang=js&"
export * from "./stuRolls.vue?vue&type=script&lang=js&"
import style0 from "./stuRolls.vue?vue&type=style&index=0&id=4ef7ff40&prod&lang=less&"
import style1 from "./stuRolls.vue?vue&type=style&index=1&id=4ef7ff40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7ff40",
  null
  
)

export default component.exports